"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _hoisted_1 = { style: { "margin-top": "10%" } };
var _hoisted_2 = {
    class: "input",
    style: { "position": "relative", "margin": "auto", "width": "fit-content" }
};
var _hoisted_3 = {
    class: "mobleInfo",
    style: { "width": "450px", "position": "relative", "margin-left": "auto", "margin-right": "auto", "margin-top": "20px" }
};
var _hoisted_4 = /*#__PURE__*/ vue_1.createElementVNode("div", {
    class: "tip div-center",
    style: { "padding": "20px 16px", "background-color": "#ecf8ff", "border-radius": "4px", "border-left": "5px solid #50bfff", "margin": "20px 0", "bottom": "0", "position": "fixed", "width": "100%" }
}, [
    /*#__PURE__*/ vue_1.createElementVNode("p", { style: { "font-size": "18px" } }, "使用说明:"),
    /*#__PURE__*/ vue_1.createElementVNode("blockquote", null, [
        /*#__PURE__*/ vue_1.createElementVNode("p", null, [
            /*#__PURE__*/ vue_1.createElementVNode("i", null, "输入全球国家名称都可以生成对应手机号，并通过谷歌全球手机校验库规则。"),
            /*#__PURE__*/ vue_1.createElementVNode("br"),
            /*#__PURE__*/ vue_1.createElementVNode("i", null, " 生成信息，是通过相关信息规则随机、虚拟生成，并非真实信息，仅供测试使用，请勿用于非法用途。 ")
        ])
    ])
], -1);
function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_a_select = vue_1.resolveComponent("a-select");
    var _component_a_form_item = vue_1.resolveComponent("a-form-item");
    var _component_a_button = vue_1.resolveComponent("a-button");
    var _component_a_form = vue_1.resolveComponent("a-form");
    var _component_a_descriptions_item = vue_1.resolveComponent("a-descriptions-item");
    var _component_a_descriptions = vue_1.resolveComponent("a-descriptions");
    return (vue_1.openBlock(), vue_1.createElementBlock(vue_1.Fragment, null, [
        vue_1.createElementVNode("div", _hoisted_1, [
            vue_1.createElementVNode("div", _hoisted_2, [
                vue_1.createVNode(_component_a_form, {
                    layout: "inline",
                    model: _ctx.formState,
                    name: "basic",
                    onFinish: _ctx.onFinish,
                    onFinishFailed: _ctx.onFinishFailed
                }, {
                    default: vue_1.withCtx(function () { return [
                        vue_1.createVNode(_component_a_form_item, {
                            label: "国家/地区",
                            name: "country",
                            rules: [{ required: true, message: '国家必填' }]
                        }, {
                            default: vue_1.withCtx(function () { return [
                                vue_1.createVNode(_component_a_select, {
                                    value: _ctx.formState.country,
                                    "onUpdate:value": _cache[0] || (_cache[0] = function ($event) { return ((_ctx.formState.country) = $event); }),
                                    "show-search": "",
                                    placeholder: "Select a person",
                                    style: { "width": "200px" },
                                    options: _ctx.options,
                                    "filter-option": _ctx.filterOption
                                }, null, 8, ["value", "options", "filter-option"])
                            ]; }),
                            _: 1
                        }),
                        vue_1.createVNode(_component_a_form_item, null, {
                            default: vue_1.withCtx(function () { return [
                                vue_1.createVNode(_component_a_button, {
                                    type: "primary",
                                    "html-type": "submit",
                                    onClick: _ctx.send
                                }, {
                                    default: vue_1.withCtx(function () { return [
                                        vue_1.createTextVNode("生成")
                                    ]; }),
                                    _: 1
                                }, 8, ["onClick"])
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                }, 8, ["model", "onFinish", "onFinishFailed"])
            ]),
            vue_1.createElementVNode("div", _hoisted_3, [
                vue_1.createVNode(_component_a_descriptions, {
                    bordered: "",
                    column: 1
                }, {
                    default: vue_1.withCtx(function () { return [
                        vue_1.createVNode(_component_a_descriptions_item, { label: "国别号" }, {
                            default: vue_1.withCtx(function () { return [
                                vue_1.createTextVNode(vue_1.toDisplayString(_ctx.formState.countryCode), 1)
                            ]; }),
                            _: 1
                        }),
                        vue_1.createVNode(_component_a_descriptions_item, { label: "手机号" }, {
                            default: vue_1.withCtx(function () { return [
                                vue_1.createTextVNode(vue_1.toDisplayString(_ctx.formState.internationalMoble), 1)
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                })
            ])
        ]),
        _hoisted_4
    ], 64));
}
exports.render = render;
